import styled, { css, keyframes } from 'styled-components'

const keyframesShimmer = keyframes`
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
`

const shimmerAnimation = css`
  ${({ theme }) => css`
    background: linear-gradient(
      to right,
      ${theme.colors.coolGray.cool100} 8%,
      ${theme.colors.coolGray.cool150} 18%,
      ${theme.colors.coolGray.cool100} 33%
    );
  `}
  background-size: 1200px 100%;
  animation: ${keyframesShimmer} 3.5s infinite linear;
`

export const FilledTextFieldShimmer = styled.div<{ $gutterBottom?: boolean }>`
  width: 100%;
  height: 56px;
  border-radius: 4px;
  ${({ $gutterBottom }) => ($gutterBottom ? 'margin-bottom: 10px;' : '')}};
  ${shimmerAnimation}
`
